import React from "react";
import PropTypes from "prop-types";
import MCard from "components/Shared/MCard.tsx";
import { MSpinner } from "components/Shared";
import MGrid, { COL_CODE_CONTROL_NUMBER, COL_CODE_DATE } from "components/Shared/MGrid.tsx";
import WebConfig from "middlewares/WebConfig";
function PropertyCaseHistory({
  caseLinks,
  fetchingCaseLinks,
}) {

  const getPropertyCaseHistoryTable = () => {
    let colDefs = [
      { code: COL_CODE_CONTROL_NUMBER, dataSource: "controlNumber" },
      { key: "loanNumber", name: "Policy #/Loan", dataSource: "loanNumber" },
      { key: "reportType", name: "Report Type", dataSource: "reportType" },
      { key: "lender", name: "Account", dataSource: "lender" },
      { code: COL_CODE_DATE, name: "Date Completed", dataSource: "completed" },
      { key: "appraiser", name: "Field Rep", dataSource: "fieldRep" },
    ];

    const getRows = () => {
      let cases = caseLinks.map(c => {
        return {
          controlNumber: c.linkedControlIdNumber,
          loanNumber: c.policyNumber,
          reportType: c.surveyType?.name,
          lender: c.customer?.displayLabel,
          completed: c.dateCompleted,
          appraiser: c.appraiserAssigned === null || c.appraiserAssigned?.firstName === null ? "n/a" : `${c.appraiserAssigned?.firstName} ${c.appraiserAssigned?.lastName}`,
          fieldRep: c.inspectorAssigned?.firstLast ?? "",
        };
      });
      return cases;
    };

    const getReportPdf = (row) => {
      window.open(`${WebConfig.orthosRoot}/HomeOwnerPictures//${caseLinks[row].linkedControlIdNumber}-Report.pdf`);
    };

    return [
      {
        key: "grid",
        control: (
          <div className="property-case-history-table" style={{height: "320px"}}>
            <MGrid
              columnDefinitions={colDefs}
              data={getRows()}
              onRowClick={getReportPdf}
            />
          </div>
        )
      }
    ];
  };

  if (fetchingCaseLinks) return (<MSpinner />);

  return (
    <MCard
      className="property-case-history-card"
      title="Property Case History" 
      fields={getPropertyCaseHistoryTable()} 
    />
  );
}

PropertyCaseHistory.propTypes = {
  caseLinks: PropTypes.array.isRequired,
  fetchingCaseLinks: PropTypes.bool.isRequired,
};

export default PropertyCaseHistory;
